var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebsite1 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A2540",
    d: "M9.996 19.687c5.343 0 9.687-4.344 9.687-9.687 0-5.344-4.344-9.687-9.687-9.687C4.652.313.309 4.656.309 10s4.343 9.687 9.687 9.687m-7.5-5.828 3.937-.031a14 14 0 0 0 2.172 4.484c-2.672-.437-4.906-2.14-6.109-4.453m4.937-6.515h4.906c.36 1.718.36 3.484.032 5.203l-4.938.03a12.8 12.8 0 0 1 0-5.233m2.453 10.609a12.5 12.5 0 0 1-2.14-4.125l4.297-.031a13.2 13.2 0 0 1-2.157 4.156m1.25.406a13.8 13.8 0 0 0 2.204-4.578l4.203-.031a8.46 8.46 0 0 1-6.407 4.609m7.297-8.36c0 .876-.14 1.72-.375 2.5l-4.422.032a14.1 14.1 0 0 0-.03-5.187h4.39c.28.828.437 1.734.437 2.656m-.969-3.905h-4.156a14.4 14.4 0 0 0-2.172-4.453 8.4 8.4 0 0 1 6.328 4.453m-5.453 0h-4.25a12.9 12.9 0 0 1 2.125-4.047 12.9 12.9 0 0 1 2.125 4.047M8.605 1.687a13.9 13.9 0 0 0-2.14 4.407H2.527a8.4 8.4 0 0 1 6.078-4.407M6.168 7.344a14.4 14.4 0 0 0-.016 5.234l-4.172.031a8.305 8.305 0 0 1 .016-5.266z"
  })));
};
export default SvgWebsite1;